import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { SepaFields, emptySepa, sepaValid } from "@/components/SepaFields";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Landmark } from "lucide-react";

export function SepaSwitchDialog({ open, onOpenChange, authHeaders, billingMethod, onDone }) {
  const [sepa, setSepa] = useState(emptySepa);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!sepaValid(sepa)) return toast.error("Bitte Kontoinhaber, gültige IBAN und Mandat-Bestätigung angeben.");
    setSaving(true);
    try {
      const { data } = await api.post("/admin/billing/sepa", sepa, { headers: authHeaders });
      const next = new Date(data.next_debit_on).toLocaleDateString("de-DE");
      toast.success(data.immediate_debit
        ? `Lastschrift aktiv. Der fällige Beitrag wird jetzt eingezogen, danach alle 4 Wochen (nächster Abo-Einzug: ${next}).`
        : `Lastschrift aktiv. Erster Einzug am ${next}, danach alle 4 Wochen.`);
      setSepa(emptySepa);
      onOpenChange(false);
      onDone?.(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Umstellung fehlgeschlagen.");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-3xl" data-testid="sepa-switch-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-emerald-900 flex items-center gap-2">
            <Landmark className="w-5 h-5" /> Auf SEPA-Lastschrift umstellen
          </DialogTitle>
          <DialogDescription className="text-sm text-stone-500">
            {billingMethod === "banktransfer"
              ? "Sie erhalten künftig keine Überweisungsrechnungen mehr. Eine noch offene Rechnung wird storniert und stattdessen per Lastschrift eingezogen."
              : "Ihr bisheriges Kartenabo wird beendet. Der Einzug erfolgt ab dem Ende des bezahlten Zeitraums per Lastschrift."}
          </DialogDescription>
        </DialogHeader>
        <SepaFields value={sepa} onChange={setSepa} />
        <Button onClick={submit} disabled={saving} data-testid="sepa-switch-submit"
          className="w-full h-12 rounded-xl bg-emerald-900 hover:bg-emerald-800 text-white">
          {saving ? <><Loader2 className="mr-2 w-4 h-4 animate-spin" /> Wird umgestellt…</> : "Mandat erteilen & umstellen"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
